<template>
  <Modal
    :show="showInlineCommentModal"
    width="large"
    hide-default-actions
    @close="onClose"
  >
    <template #title>
      Add comment
    </template>

    <template #content>
      <div>
        <TiptapWrap
          :value="inlineCommentSelection"
          :editor-id="'comment'"
          :is-read-only="true"
        />
      </div>

      <div class="mt-8">
        <InlineCommentComposer
          :thread-location="threadLocation"
          :thread-meta-data="threadMetaData"
          :thread-name="threadName"
          @close="onClose"
          @message-send="onMessageSend"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useCommenting } from '@/stores/commenting/commenting';
import Modal from '@/components/shared/Modal.vue';
import TiptapWrap from '@ui/components/editor/TiptapWrap/TiptapWrap.vue';
import InlineCommentComposer from './InlineCommentComposer.vue';

export default {
  name: 'InlineCommentModal',

  components: { InlineCommentComposer, Modal, TiptapWrap },

  props: {
    threadLocation: { type: Object, default: () => null },
    threadMetaData: { type: Object, default: () => null },
    threadName: { type: String, default: '' },
  },

  emits: ['comment-added'],

  computed: {
    ...mapState(useCommenting, ['showInlineCommentModal', 'inlineCommentSelection']),
  },

  methods: {
    ...mapActions(useCommenting, [
      'setShowInlineCommentModal', 'addEditorSelectionContentToInlineMessage',
    ]),

    onClose() {
      this.setShowInlineCommentModal(false);
    },

    async onMessageSend(event) {
      const [{ messageId, threadId }] = event.detail;
      await this.addEditorSelectionContentToInlineMessage({ threadId, messageId });
      this.$emit('comment-added');
      this.setShowInlineCommentModal(false);
    },
  },
};
</script>
